import { defineMessages } from 'react-intl'

export const FORMATS_MESSAGES = defineMessages({
  time: { id: "constants.Messages.formats.FORMATS_MESSAGES.time.f441", defaultMessage: 'D MMMM [в ]HH:mm' },
  date: { id: "constants.Messages.formats.FORMATS_MESSAGES.date.3fd4", defaultMessage: 'D MMMM' },
})
